import { ChangeEvent, useState } from 'react';
import { Box, Input, List, ListItem, Text } from '@chakra-ui/react';

import { countries } from 'app/constants/countries';

import { CountryProps, CountrySearchListProps } from './types';

function CountrySearchList({ onChange }: CountrySearchListProps) {
  const [filteredList, setFilteredList] = useState<CountryProps[]>(countries);
  const [selectedItem, setSelectedItem] = useState<CountryProps | undefined>(undefined);

  const handleSearch = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value.toLowerCase();
    const result =
      countries.filter((country) => {
        return country.details.name.toLowerCase().includes(value);
      }) || [];

    setFilteredList(result);
  };

  return (
    <Box
      my={1}
      maxH="xs"
      bg="white"
      width="full"
      zIndex={998}
      height="auto"
      overflow="auto"
      borderRadius="lg"
      position="absolute"
      boxShadow="0px 1px 30px rgba(0, 0, 0, 0.1)"
    >
      <Box position="sticky" top="0" padding={4} bg="white">
        <Input
          size="md"
          type="search"
          borderRadius="lg"
          autoComplete="off"
          placeholder="Search for a country..."
          onChange={(event) => handleSearch(event)}
          _focusWithin={{ borderColor: 'secondary' }}
          _invalid={{ bg: 'white', borderColor: 'gray.50' }}
        />
      </Box>

      <List>
        {filteredList?.map((item: CountryProps) => (
          <ListItem
            key={item.code}
            paddingY={2}
            color="#ACB9C4"
            cursor="pointer"
            fontWeight="500"
            textTransform="capitalize"
            onClick={() => {
              onChange(item);
              setSelectedItem(item);
            }}
            style={{ transition: 'all .125s ease' }}
            _hover={{ bg: 'gray.50', color: '#396070' }}
            sx={
              item?.details.emoji === selectedItem?.details.emoji
                ? { backgroundColor: 'gray.50', color: '#396070' }
                : {}
            }
          >
            <Text as="span" mx={4}>
              {item?.details.emoji}
            </Text>
            <Text as="span">{item?.details.name}</Text>
          </ListItem>
        ))}
      </List>
    </Box>
  );
}

export default CountrySearchList;
